'use client'

import { useBazaarvoiceRatingObserver } from '@/app/components/shared/BazaarvoiceScriptLoader'
import { RatingSummary } from '@/app/components/shared/RatingSummary'
import { shouldShowRating } from '@/app/lib/ratings'

import styles from './BazaarvoiceHeaderRating.module.scss'

interface BazaarvoiceHeaderRatingProps {
  readonly productId: string
  readonly threshold: number
  /** Variante compacta de la ficha de canal (ver `RatingSummary`). */
  readonly compact?: boolean
}

/**
 * Estrella + puntuación de la cabecera de PDP para productos Bazaarvoice
 * (research.md R12): monta su propio contenedor `inline_rating` — oculto,
 * dedicado a esta instancia, independiente del de `BazaarvoiceReviews` más
 * abajo en la página — únicamente para leer el conteo/media que Bazaarvoice
 * inyecta dentro, y los redibuja con `RatingSummary` para que la cabecera
 * comparta el mismo maquetado que el sistema propio (FR-006). Nunca delega el
 * pintado visual en el marcado nativo de Bazaarvoice.
 */
export function BazaarvoiceHeaderRating({
  productId,
  threshold,
  compact,
}: BazaarvoiceHeaderRatingProps) {
  const { containerRef, reviewCount, ratingAverage } = useBazaarvoiceRatingObserver()

  return (
    <>
      <div
        ref={containerRef}
        data-bv-show="inline_rating"
        data-bv-product-id={productId}
        data-bv-seo="false"
        className={styles.hidden}
      />
      {shouldShowRating(reviewCount, threshold) && (
        <RatingSummary
          ratingSum={reviewCount}
          ratingAverage={ratingAverage}
          threshold={threshold}
          inverse={!compact}
          compact={compact}
        />
      )}
    </>
  )
}
